export const ENDPOINTS = {
  CREATE_TOKEN: "/careplix/create-token",
  ADD_SCAN: "/careplix/add-scan",
  ADD_ASSESSMENT_RESULT: "/get_active/add-assessment-result",
  GET_ASSESSMENT_RESULT: "/get_active/get-assessment-result",
  ADD_PLAN_RESULT: "/get_active/add-plan-result",
};
